import React from "react"
import PropTypes from "prop-types"
import { useSiteMetadata } from "../hooks/use-site-metadata"

function SEO({ lang = "en", pathname, pageContext, showRatings = false }) {
  const {
    title: defaultTitle,
    description: defaultDescription,
    image,
    siteUrl,
  } = useSiteMetadata()

  const {
    title,
    categoryTitle,
    recipeName,
    productTitle,
    description,
    keywords,
    schemaData,
  } = pageContext?.pageData || {}

  const seo = {
    title: title || categoryTitle || recipeName || productTitle,
    description: description || defaultDescription,
    image: `${siteUrl}${image}`,
    url: `${siteUrl}${pathname || ``}`,
    keywords: keywords,
  }

  return (
    <>
      <title>
        {seo.title ? `${seo.title} | ${defaultTitle}` : defaultTitle}
      </title>
      <meta name="description" content={seo.description} />
      {keywords && <meta name="keywords" content={seo.keywords} />}
      <meta name="og:title" content={seo.title} />
      <meta name="og:description" content={seo.description} />
      <meta name="og:type" content="website" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:url" content={seo.url} />
      <meta name="twitter:description" content={seo.description} />
      {image && (
        <>
          <meta name="og:image" content={seo.image} />
          <meta name="image" content={seo.image} />
          <meta name="twitter:image" content={seo.image} />
        </>
      )}

      {showRatings && (
        <script
          type="text/javascript"
          src={`https://apps.bazaarvoice.com/deployments/crockpot-eu/main_site/${
            process.env.NODE_ENV === "development"
              ? "staging"
              : process.env.NODE_ENV
          }/en_GB/bv.js`}
          async
        ></script>
      )}

      {lang === "en" && schemaData && (
        <script type="application/ld+json">
          {`
            {
              "@context" : "https://schema.org",
              "@type" : "Product",
              "@id" : "${siteUrl}",
              "name" : "${schemaData.productTitle}",
              "image" : "${
                schemaData.productImages?.length > 0
                  ? schemaData.productImages[0].url
                  : ""
              }",
              "description" : "${
                schemaData.productDescription
                  ? JSON.parse(schemaData.productDescription.raw).content[0]
                      .content[0].value
                  : ""
              }",
              "sku" : "${schemaData.skuProductId}",
              "brand" : "${schemaData.page}"
            }
          `}
        </script>
      )}
    </>
  )
}

SEO.propTypes = {
  pathname: PropTypes.string,
  lang: PropTypes.string,
  pageContext: PropTypes.object,
  showRatings: PropTypes.bool,
}

export default SEO
